export const RAFFLE_TYPE_TALONARIO = "talonario";

// El comprador elige sus números (en vez de recibirlos aleatorios)
export const hasSelectableNumbers = (raffleType?: string) =>
  raffleType === "lottery" || raffleType === RAFFLE_TYPE_TALONARIO;

export const isTalonario = (raffleType?: string) => raffleType === RAFFLE_TYPE_TALONARIO;

// Talonario solo admite 100 o 1000 números para que la imagen del talonario sea legible
export const TALONARIO_MAX_LIMIT = 1000;
